/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { CreateStaffMemberDto } from "../types/createStaffMemberDto";

import type { ListStaffMembersParams } from "../types/listStaffMembersParams";

import type { ProblemDetails } from "../types/problemDetails";

import type { StaffMemberDto } from "../types/staffMemberDto";

import type { StaffMemberDtoPaginatedResult } from "../types/staffMemberDtoPaginatedResult";

import type { UpdateStaffMemberDto } from "../types/updateStaffMemberDto";

import type { UpdateStaffRoleDto } from "../types/updateStaffRoleDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_STAFF_GET
 */
export const getStaffMemberById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StaffMemberDto>> => {
  return axios.default.get(`/api/staff/${id}`, options);
};

export const getGetStaffMemberByIdQueryKey = (id?: string) => {
  return [`/api/staff/${id}`] as const;
};

export const getGetStaffMemberByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getStaffMemberById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaffMemberById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStaffMemberByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStaffMemberById>>
  > = ({ signal }) => getStaffMemberById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStaffMemberById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStaffMemberByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStaffMemberById>>
>;
export type GetStaffMemberByIdQueryError = AxiosError<void | ProblemDetails>;

export function useGetStaffMemberById<
  TData = Awaited<ReturnType<typeof getStaffMemberById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaffMemberById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStaffMemberByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_STAFF_UPDATE
 */
export const updateStaffMember = (
  id: string,
  updateStaffMemberDto: UpdateStaffMemberDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StaffMemberDto>> => {
  return axios.default.put(`/api/staff/${id}`, updateStaffMemberDto, options);
};

export const getUpdateStaffMemberMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaffMember>>,
    TError,
    { id: string; data: UpdateStaffMemberDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStaffMember>>,
  TError,
  { id: string; data: UpdateStaffMemberDto },
  TContext
> => {
  const mutationKey = ["updateStaffMember"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStaffMember>>,
    { id: string; data: UpdateStaffMemberDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStaffMember(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStaffMember>>
>;
export type UpdateStaffMemberMutationBody = UpdateStaffMemberDto;
export type UpdateStaffMemberMutationError = AxiosError<ProblemDetails | void>;

export const useUpdateStaffMember = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaffMember>>,
    TError,
    { id: string; data: UpdateStaffMemberDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStaffMember>>,
  TError,
  { id: string; data: UpdateStaffMemberDto },
  TContext
> => {
  const mutationOptions = getUpdateStaffMemberMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_STAFF_DELETE
 */
export const removeStaffMember = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.delete(`/api/staff/${id}`, options);
};

export const getRemoveStaffMemberMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStaffMember>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStaffMember>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["removeStaffMember"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStaffMember>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return removeStaffMember(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStaffMember>>
>;

export type RemoveStaffMemberMutationError = AxiosError<ProblemDetails | void>;

export const useRemoveStaffMember = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStaffMember>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStaffMember>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRemoveStaffMemberMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_STAFF_LIST
 */
export const listStaffMembers = (
  params?: ListStaffMembersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StaffMemberDtoPaginatedResult>> => {
  return axios.default.get(`/api/staff`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListStaffMembersQueryKey = (
  params?: ListStaffMembersParams,
) => {
  return [`/api/staff`, ...(params ? [params] : [])] as const;
};

export const getListStaffMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listStaffMembers>>,
  TError = AxiosError<void>,
>(
  params?: ListStaffMembersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStaffMembers>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListStaffMembersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStaffMembers>>
  > = ({ signal }) => listStaffMembers(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStaffMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStaffMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStaffMembers>>
>;
export type ListStaffMembersQueryError = AxiosError<void>;

export function useListStaffMembers<
  TData = Awaited<ReturnType<typeof listStaffMembers>>,
  TError = AxiosError<void>,
>(
  params?: ListStaffMembersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStaffMembers>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStaffMembersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_STAFF_CREATE
 */
export const createStaffMember = (
  createStaffMemberDto: CreateStaffMemberDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StaffMemberDto>> => {
  return axios.default.post(`/api/staff`, createStaffMemberDto, options);
};

export const getCreateStaffMemberMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStaffMember>>,
    TError,
    { data: CreateStaffMemberDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStaffMember>>,
  TError,
  { data: CreateStaffMemberDto },
  TContext
> => {
  const mutationKey = ["createStaffMember"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStaffMember>>,
    { data: CreateStaffMemberDto }
  > = (props) => {
    const { data } = props ?? {};

    return createStaffMember(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStaffMember>>
>;
export type CreateStaffMemberMutationBody = CreateStaffMemberDto;
export type CreateStaffMemberMutationError = AxiosError<ProblemDetails | void>;

export const useCreateStaffMember = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStaffMember>>,
    TError,
    { data: CreateStaffMemberDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStaffMember>>,
  TError,
  { data: CreateStaffMemberDto },
  TContext
> => {
  const mutationOptions = getCreateStaffMemberMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_STAFF_UPDATE
 */
export const updateStaffMemberRole = (
  id: string,
  updateStaffRoleDto: UpdateStaffRoleDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StaffMemberDto>> => {
  return axios.default.put(
    `/api/staff/${id}/role`,
    updateStaffRoleDto,
    options,
  );
};

export const getUpdateStaffMemberRoleMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaffMemberRole>>,
    TError,
    { id: string; data: UpdateStaffRoleDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStaffMemberRole>>,
  TError,
  { id: string; data: UpdateStaffRoleDto },
  TContext
> => {
  const mutationKey = ["updateStaffMemberRole"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStaffMemberRole>>,
    { id: string; data: UpdateStaffRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStaffMemberRole(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStaffMemberRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStaffMemberRole>>
>;
export type UpdateStaffMemberRoleMutationBody = UpdateStaffRoleDto;
export type UpdateStaffMemberRoleMutationError =
  AxiosError<ProblemDetails | void>;

export const useUpdateStaffMemberRole = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaffMemberRole>>,
    TError,
    { id: string; data: UpdateStaffRoleDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStaffMemberRole>>,
  TError,
  { id: string; data: UpdateStaffRoleDto },
  TContext
> => {
  const mutationOptions = getUpdateStaffMemberRoleMutationOptions(options);

  return useMutation(mutationOptions);
};
